module.exports = __webpack_public_path__ + "static/media/agent-real-time.423c9c7d.png";